import client from './client';

export const getScenes = async (gameId) => {
  const response = await client.get(`/api/games/${gameId}/scenes`);
  return response.data;
};

export const getScene = async (gameId, sceneId) => {
  const response = await client.get(`/api/games/${gameId}/scenes/${sceneId}`);
  return response.data;
};

export const createScene = async (gameId, sceneData) => {
  const response = await client.post(`/api/games/${gameId}/scenes`, sceneData);
  return response.data;
};

export const updateScene = async (gameId, sceneId, sceneData) => {
  const response = await client.put(`/api/games/${gameId}/scenes/${sceneId}`, sceneData);
  return response.data;
};

export const addSceneAspect = async (gameId, sceneId, aspectData) => {
  const response = await client.post(`/api/games/${gameId}/scenes/${sceneId}/aspects`, aspectData);
  return response.data;
};

export const removeSceneAspect = async (gameId, sceneId, aspectIndex) => {
  const response = await client.delete(`/api/games/${gameId}/scenes/${sceneId}/aspects/${aspectIndex}`);
  return response.data;
};

export const deleteScene = async (gameId, sceneId) => {
  const response = await client.delete(`/api/games/${gameId}/scenes/${sceneId}`);
  return response.data;
};

export const addCharacterToScene = async (gameId, sceneId, characterId) => {
  const response = await client.post(`/api/games/${gameId}/scenes/${sceneId}/characters/${characterId}`);
  return response.data;
};

export const removeCharacterFromScene = async (gameId, sceneId, characterId) => {
  const response = await client.delete(`/api/games/${gameId}/scenes/${sceneId}/characters/${characterId}`);
  return response.data;
};
